import _ from 'lodash'
import { TransitionDropList } from '@vzmi/shp_shared_compo'
import { FormValueSelector } from '../../../Common/forms'
import withProposalListingFormUploadFiles from '../../../Proposal/Common/HOC/withProposalListingFormUploadFiles'
import Video from '../../../Proposal/Common/ProposalForm/Video/Video'
import StatusPrefixBlock from '../../Common/PrefixBlock/Status'
import DuplicatedPrefixBlock, {
  getDuplicatedSkuInSpecsList
} from '../../Common/PrefixBlock/Duplicated'
import ListingCollapseBlock from '../../Common/ListingCollapseBlock'
import styles from './index.css'
const {
  TransitionDropListContainer,
  TransitionDropItem
} = TransitionDropList

const ListingVideoRow = props => {
  const {
    index,
    listing,
    duplicatedMap,
    proposalType,
    batchResult,
    readOnly,
    onRemove,
    isOverviewPage,
    onLayoutChange
  } = props

  const {
    id: listingId,
    models = [],
    isNoModelsListing
  } = listing
  const listingFieldPrefix = `listings[${index}]`
  const checkedVideos = isNoModelsListing ? `${listingFieldPrefix}.videos[0]` : `${listingFieldPrefix}.models[0].videos[0]`
  const duplicatedList = _.get(duplicatedMap, listingId, [])
  const isDuplicatedListExist = (
    !_.isEmpty(duplicatedList) &&
    // 如果發現有共用商品但 listings 是空的
    // 代表除了此賣場外沒有跟其他賣場有重複的 sku
    // 也就是說同一個雙層屬性賣場內不同商品的第二層屬性有一樣的屬性
    // 這是從 ERP 調整沒經過驗證，預期外的資料，會從 DuplicatedPrefixBlock 另外判斷
    !_.isEmpty(_.get(duplicatedList, '0.listings'))
  )
  const duplicatedSkuInSpecsList = getDuplicatedSkuInSpecsList(models)
  const isDuplicatedSkuInSpecsListExist = !_.isEmpty(duplicatedSkuInSpecsList)

  return (
    <>
      {/* 更新成功失敗區塊 */}
      <StatusPrefixBlock
        proposalType={proposalType}
        listing={listing}
        batchResult={batchResult}
        isOverviewPage={isOverviewPage}
      />
      {/* 賣場含有共用商品區塊 */}
      <DuplicatedPrefixBlock
        proposalType={proposalType}
        duplicatedMap={duplicatedMap}
        listing={listing}
      />
      {/* 賣場區塊 */}
      <ListingCollapseBlock
        batchResult={batchResult}
        proposalType={proposalType}
        onRemove={onRemove}
        onCollapseChange={onLayoutChange()}
        listing={listing}
        readOnly={readOnly}
      >
        {/* 修改影片功能 */}
        <div className={styles.videoBox}>
          <Video
            fieldName={checkedVideos}
            readOnly={readOnly || isDuplicatedListExist || isDuplicatedSkuInSpecsListExist}
            index={index}
          />
        </div>
      </ListingCollapseBlock>
    </>
  )
}

const ListingVideoRows = props => {
  const {
    readOnly,
    onRemove,
    batchResult,
    duplicatedMap = {},
    isOverviewPage,
    proposalType,
    isEditPage,
    isConfirmPage
  } = props

  return (
    <FormValueSelector
      // redux proposal form listings
      selector={select => ({
        listings: select('listings')
      })}
    >
      {({ listings = [] }) => {
        return (
          // 刪除賣場轉場容器
          <TransitionDropListContainer>
            {listings.map((listing, index) => {
              const {
                id: listingId
              } = listing

              return (
                // 刪除賣場轉場項目
                <TransitionDropItem
                  key={listingId}
                  id={listingId}
                >
                  {onLayoutChange => {
                    return (
                      <ListingVideoRow
                        listing={listing}
                        index={index}
                        duplicatedMap={duplicatedMap}
                        proposalType={proposalType}
                        batchResult={batchResult}
                        readOnly={readOnly}
                        onRemove={onRemove}
                        isOverviewPage={isOverviewPage}
                        isEditPage={isEditPage}
                        isConfirmPage={isConfirmPage}
                        onLayoutChange={onLayoutChange}
                      />
                    )
                  }}
                </TransitionDropItem>
              )
            })}
          </TransitionDropListContainer>
        )
      }}
    </FormValueSelector>
  )
}

export default withProposalListingFormUploadFiles(ListingVideoRows)
